import React, { useContext } from 'react'
import { AuthenticationContext } from 'app/Contexts/AuthenticationProvider'
import { routes } from 'app/routes'
import styled from 'styled-components'
import { Card } from 'app/components/ui/Card'
import { Text } from 'app/components/ui/Text'
import { CardListItem } from 'app/components/shared/CardListItem'
import { themeEstra } from 'app/styles/themeEstra'
import { Button } from 'app/components/ui/Button'
import { Container } from 'app/components/ui/Container'

interface Props {
  onReUploadDocumentRequest?: () => void
}

export const ShowData: React.FC<Props> = ({ onReUploadDocumentRequest }) => {
  const authCtx = useContext(AuthenticationContext)

  const supplier = authCtx?.actor?.supplier

  if (!supplier) return null

  const isProfileDataCompleted = supplier.status !== 'invited'

  return (
    <ProfileContainer>
      <ProfileCard shadow padding={'3rem'} mobilePadding={'2rem'}>
        <Text mb={2} variant='s24' weight='700'>
          DETTAGLI PROFILO
        </Text>
        <CardListItem label={'Username'}>
          <Text color={themeEstra.color.primari.grigioEstra} variant='s20'>
            {authCtx?.actor?.email}
          </Text>
        </CardListItem>
        {supplier.company_fiscal_code ? (
          <CardListItem label={'Codice Fiscale'}>
            <Text color={themeEstra.color.primari.grigioEstra} variant='s20'>
              {supplier.company_fiscal_code}
            </Text>
          </CardListItem>
        ) : null}
        {supplier.company_vat ? (
          <CardListItem label={'Partita Iva'}>
            <Text color={themeEstra.color.primari.grigioEstra} variant='s20'>
              {supplier.company_vat}
            </Text>
          </CardListItem>
        ) : null}
        {supplier.pdf_registry_url ? (
          <CardListItem label={'Anagrafica completa'}>
            <a
              href={supplier.pdf_registry_url}
              target='_blank'
              rel='noopener noreferrer'
              className=''
            >
              <Text variant='s20'>Vedi PDF</Text>
            </a>
          </CardListItem>
        ) : null}
        {isProfileDataCompleted ? (
          <ActionsWrapper>
            <Text
              variant='s18'
              mt={1.5}
              mb={1.5}
              color={themeEstra.color.primari.grigioEstra}
            >
              Cliccando uno dei pulsanti in basso procederai alla modifica dei
              tuoi dati anagrafici o del tuo documento di identità.
            </Text>
            <ButtonWrapper>
              <Button to={routes.editProfile.makeUrl()}>
                Aggiorna i tuoi dati
              </Button>
              <Button onClick={onReUploadDocumentRequest}>
                Aggiorna documento titolare
              </Button>
            </ButtonWrapper>
          </ActionsWrapper>
        ) : null}
      </ProfileCard>
    </ProfileContainer>
  )
}
const ProfileContainer = styled(Container)``

const ProfileCard = styled(Card)`
  max-width: 700px;
  margin-right: auto;
  margin-left: auto;
`

const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  margin-top: 4rem;
`
const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 2rem;

  > * {
    margin-bottom: 1.5rem;
  }
`
